import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { OBSIDIAN, OBSIDIAN_DISPLAY_FONT } from '../../constants/obsidianDashboardTheme';
import { SandboxMyOfficeHoursPanel } from './SandboxMyOfficeHoursPanel';

type Props = {
    open: boolean;
    onClose: () => void;
    onBook?: () => void;
    emptyHint?: string;
};

/** Standalone sessions dialog (e.g. Academy when no bookable mentor card). */
export function SandboxMyOfficeHoursModal({ open, onClose, onBook, emptyHint }: Props) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                    bgcolor: OBSIDIAN.surfaceContainerHigh,
                    backgroundImage: 'none',
                    borderRadius: 3,
                },
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 2 }}>
                <Typography sx={{ fontFamily: OBSIDIAN_DISPLAY_FONT, fontWeight: 800, color: OBSIDIAN.onSurface }}>
                    My office hours
                </Typography>
                <IconButton onClick={onClose} size="small" sx={{ color: OBSIDIAN.onSurfaceVariant }}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ px: 2.5, pb: 3, maxHeight: '70vh', overflow: 'auto' }}>
                <SandboxMyOfficeHoursPanel active={open} emptyHint={emptyHint} onBook={onBook} />
            </Box>
        </Dialog>
    );
}
